// Для yandex-team встреч uri от бэка приходит в виде http://telemost.yandex-team.ru/j/123
// но это невалидный uri для запросов в cloud api. Поэтому нормализуем uri, убирая yandex-team.
// https://st.yandex-team.ru/CHEMODAN-89719
export function normalizeConferenceUri(uri: string) {
    return uri.replace('yandex-team', 'yandex');
}
